import { Icon, Icons } from '@Components/icon/Icon.tsx';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { Sidebar } from 'primereact/sidebar';

interface IProps {
  images?: string[];
  sideBarVisibile?: boolean;
  setSideBarVisible?: () => void;
}

export const InfoSIdeBar = ({ images, sideBarVisibile, setSideBarVisible = () => {} }: IProps) => {
  return (
    <>
      <div className='card flex justify-content-center'>
        <Sidebar
          position='right'
          className='sm:min-w-[520px] sm:max-w-[520px] w-full '
          visible={sideBarVisibile}
          onHide={() => setSideBarVisible()}
          content={() => (
            <>
              <div className='min-h-screen overflow-y-scroll bg-surface-primary-bw-00 flex relative md:static surface-section surface-border border-left-1 shadow-md surface-ground sm:min-w-[520px] w-full pb-[32px]'>
                <div className='h-[24px]  w-full mb-[24px]'>
                  <div className='p-[16px] sm:pr-[36px] flex sm:justify-start items-center justify-between border-b-2 border-b-outline-primary-bw-03 w-full overflow-y-scroll'>
                    <Icon
                      id='required-doc-example__close'
                      className='cursor-pointer mr-[190px]'
                      icon={Icons.ExitIcon}
                      onClick={() => setSideBarVisible()}
                    />
                    <Heading.H8 fontWeight={FontWeight.MEDIUM}>Example</Heading.H8>
                  </div>
                  <div className='flex flex-col gap-[22px] items-center pt-[24px] pb-[24px]'>
                    {images?.map((image, index) => {
                      return (
                        <div className='w-[347px] mb-[22px] h-[369px] flex flex-col items-center  border-outline-primary-bw-03 p-1 rounded-sm'>
                          <div className='rounded-full top-[15px] relative text-[23.8px]  w-[34px] h-[34px] bg-surface-primary-bw-05 text-outline-primary-bw-00 flex items-center justify-center'>
                            {index + 1}
                          </div>
                          <img
                            id='required-doc-example__preview-image'
                            src={image}
                            alt='alt'
                            className='contain max-h-[369px] w-[357px]'
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}></Sidebar>
      </div>
    </>
  );
};
